import { numberToCurrency } from '@hc-frontend/utils'
import getBenefitsTooltips from 'utils/pivot/plan/getBenefitsTooltips'
import tooltipMessage from 'core/controllerPlans/tooltipMessage'
import getCorrespondingDuration from 'core/services/getPlansByProductId/getCorrespondingDuration'
import { toString as toProductName } from 'utils/pivot/product'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import moneyFormat from 'utils/format/money'
import getPlanDetailTooltip from 'utils/pivot/plan/getPlanDetailTooltip'
import getCoverageLabel from 'utils/plans/getCoverageLabel'

function renderRecommended(node, template, store, plansToShow, useMaxPolicy = false) {
  node.innerHTML = plansToShow
    .map((id, index) => {
      const plan = store.plans[id]

      const planDuration = getCorrespondingDuration({
        plan,
        mainPeriod: store.period,
        additionalPeriods: store.additionalPeriods
      })
      const productName = toProductName(plan.productId)
      const carrier = store.carriers[plan.carrierId]
      const policies = Object.keys(planDuration)
      const maxPolicy = policies[policies.length - 1]

      const policy = useMaxPolicy
        ? planDuration[maxPolicy]
        : planDuration['1'] || planDuration[maxPolicy]

      const maxPolicyDuration = planDuration[maxPolicy]
      const hasExtended = maxPolicyDuration.extendedDurationsAvailable.length > 0

      const period = policy.policyDuration
      const enrollment = policy.monthly.fees
        .filter(({ name }) => name === 'Application Fee')
        .reduce((acc, fee) => acc + fee.value, 0)
      const isEpic = isEpicPlan(plan)

      const recommendedPolicies =
        store.recommendDurations[id] && store.recommendDurations[id].policies

      const recurrence = planDuration[recommendedPolicies]
        ? store.recommendDurations[id].policies
        : policy.recurrence
      const compare = store.plansToCompare.includes(`${id}-${period}-${recurrence}`)

      const periodTitle = getCoverageLabel({
        plan,
        duration: period
      })

      return template(
        {
          index,
          plan,
          productName,
          recurrence,
          carrier,
          period: policy.policyDuration,
          premium: +policy.monthly.premium,
          hasExtended,
          periodTitle,
          enrollment,
          tooltip: {
            planDescription: getPlanDetailTooltip(plan, isEpic),
            cost: tooltipMessage(store, plan, policy['monthly']),
            ...getBenefitsTooltips()
          },
          compare
        },
        {
          money: numberToCurrency,
          asMoney: moneyFormat
        }
      )
    })
    .join('')
}

export default renderRecommended
